import ICashFinancing from "./ICashFinancing";
import CashFinancingType from "./CashFinancingTypeEnum";
import ISettingsLoanWallet from "./ISettingsLoanWallet";
import ISettingsCashLoan from "@/module/main/dto/financing-v3/ISettingsCashLoan";

export default class CashFinancing implements ICashFinancing {
    constructor(
        public type: CashFinancingType = CashFinancingType.LOAN_WALLET,
        public loanWallet?: ISettingsLoanWallet,
        public cashLoan?: ISettingsCashLoan
    ) {}
}
